<template>
    <div>
        <sweet-modal ref="operatorMenuModal" :modal-theme="$vuetify.theme.dark === true ? 'dark' : 'light'" :overlay-theme="$vuetify.theme.dark === true ? 'light' : 'dark'" blocking>

            <v-container v-if="!isBusy">
                <h3 class="mb-3">
                    Edit Operator Menu
                </h3>

                <v-list>
                    <v-list-item v-for="menu in menus"
                                 :key="menu.id">
                        <v-list-item-content class="text-left">
                            <v-list-item-title v-text="menu.name"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-btn icon v-if="menu.isSelected" @click="onRemoveMenuItem(menu.opertatorMenuItemId)">
                                <v-icon color="green lighten-1">mdi-check-circle</v-icon>
                            </v-btn>
                            <v-btn icon v-if="!menu.isSelected" @click="onAddMenuItem(menu.id)">
                                <v-icon color="grey lighten-1">mdi-checkbox-blank-circle-outline</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-container>

            <v-container v-if="isBusy">
                <v-skeleton-loader v-if="isBusy" v-bind="attrs"
                                   type="table-heading, list-item-two-line, image, table-tfoot"></v-skeleton-loader>
            </v-container>

        </sweet-modal>
    </div>
</template>

<script>
    import OperatorService from "../../services/operatorService.js"
    import MenuItemService from "../../services/menuItemService.js"
    export default {
        data() {
            return {
                operatorId: "",
                attrs: null,
                accessToken: "",
                isBusy: true,
                operatorMenus: [],
                menus: []
            }
        },
        created() {
            this.setup();
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();
            },
            async open(operatorId) {
                this.$refs.operatorMenuModal.open();

                this.operatorId = operatorId;

                await this.getOperatorMenus();
            },
            async getOperatorMenus() {
                this.isBusy = true;

                const result = await OperatorService.getOperatorById(this.operatorId, this.accessToken);

                const menus = await MenuItemService.searchMenuItems(this.accessToken, "", 1, 1000, "Order", "ASCENDING");

                if (menus) {
                    this.menus = menus.data;

                    this.menus.forEach(menu => menu.isSelected = false);

                    if (result && result.operatorMenuItems) {
                        this.menus.forEach(menu => {
                            const operatorMenuItem = result.operatorMenuItems.find(op => op.menuItemId === menu.id);
                            if (operatorMenuItem) {
                                menu.isSelected = true;
                                menu.opertatorMenuItemId = operatorMenuItem.id;
                            }
                        });
                    }
                }

                this.isBusy = false;
            },
            async onAddMenuItem(menuItemId) {
                this.isBusy = true;

                const request = {
                    menuItemId: menuItemId
                }

                const result = await OperatorService.addOperatorMenu(this.operatorId, request, this.accessToken);

                if (result) {
                    await this.getOperatorMenus();
                }

                this.isBusy = false;
            },
            async onRemoveMenuItem(operatorMenuId) {
                this.isBusy = true;

                const result = await OperatorService.deleteOperatorMenuById(this.operatorId, operatorMenuId, this.accessToken);

                if (result) {
                    await this.getOperatorMenus();
                }

                this.isBusy = false;
            },
        }
    };
</script>
